// src/components/Header.tsx
import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import SignOut from '@mui/icons-material/Logout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Redux/store/ReduxStore';
import Logo from "../assets/company_logo.png";
import { logOff, setAuthentication } from '../Redux/Reducer/AuthReducer';
import vedantaLogo from "../assets/Vedanta.png"

type HeaderProps = {
  toggleSidebar: () => void;
};

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector((state: RootState) => state.auth);

    useEffect(() => {
      if (location.pathname === '/app') {
        navigate('checkin');
      }
      // else{
      //   return null;
      // }
    }, [location, navigate,user]);

    const logout = () => {
      dispatch(logOff())
    }
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="static" color='transparent' style={{height:'80px'}}>
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleSidebar}>
          <MenuIcon titleAccess='menu' />
        </IconButton>
        <Box flexGrow={1} display='flex' justifyContent="space-between" flexWrap="wrap" gap={isMobile ? 1 : 2}
        // flexDirection={isMobile ? 'column' : 'row'} // Stack logos on mobile view
          alignItems="center"
          >
          <img src={Logo} alt="Logo" 
            style={{
              width: isMobile ? '120px' : '150px',
              height: 'auto',
              maxHeight: '80px',
              alignItems:"center"
            }} 
          />
          <img src={vedantaLogo} alt="vedanta"
            style={{
              width: isMobile ? '100px' : '120px',
              height: 'auto',
              maxHeight: 'auto',
            }}
          />
        </Box>
        <IconButton edge="end" color="inherit" aria-label="menu" onClick={logout} sx={{ marginLeft: isMobile ? 0 : '20px' }}>
          <SignOut titleAccess='Sign out' />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
